import $ from 'jquery';
import CommonLog from "awt-common-log/dist/common.log";

export function getCmsLogger() {
    if (window.cmsConstants) {
        var logServiceEndpoint = window.cmsConstants.LOGGER_SERVICE_END_POINT || window.cmsConstants.LOGGER_SERVICE_END_POINT_DEFAULT;
        var logLevelMinServer = window.cmsConstants.LOGGER_LEVEL_MIN_SERVER || window.cmsConstants.LOGGER_LEVEL_MIN_SERVER_DEFAULT;
        var logLevelMinClient = window.cmsConstants.LOGGER_LEVEL_MIN_CLIENT || window.cmsConstants.LOGGER_LEVEL_MIN_CLIENT_DEFAULT;
    } else {
        var logServiceEndpoint = "/extrestcontent/logBigData";
        var logLevelMinServer = "error";
        var logLevelMinClient = "error";
    }
     const log = new CommonLog({
        logServicesUrls:  {
            defaut: logServiceEndpoint
        },
        niveauMinimalLogSurServeur: logLevelMinServer,
        niveauMinimalLogSurClient: logLevelMinClient
    });

    return {
        log,
        generateLogIfEmpty,
        generateLogValue,
        generateDebugMsg,
        generateErrorMsg
    }
}

/*
    Generate Log if no value,
    if goReturn is "true" stop the log process because this variable is required
 */
 function generateLogIfEmpty(debugInfo, params) {
     var isRequired = debugInfo.isRequired;

    // default isRequired to false
     isRequired = typeof isRequired !== 'undefined' ? isRequired : false;

    if(!debugInfo.valueToCheck || 0 === debugInfo.valueToCheck.length) {
        this.log[debugInfo.logLevel](debugInfo.category + " - " + debugInfo.message + debugInfo.param, params);

        if(isRequired) {
            return;
        }
    }
}

function generateLogValue(debugInfo, params) {
    if(debugInfo.valueToCheck) {
        this.log.info(debugInfo.category + " - " + debugInfo.message + '"' + debugInfo.param + '" : ' + debugInfo.valueToCheck, params);
    }
}

// Generate Debug Msg
function generateDebugMsg(debugInfo, params) {
    this.log.info(debugInfo.category + " - " + debugInfo.message, params);
}

function generateErrorMsg(cat, msg, variable = "") {
    this.log.error(cat + " - " + msg + variable);
}



// WEBPACK FOOTER //
// ./src/js/api/CmsLogger.js